import { css } from "@emotion/react";
import { fontSizes, gutterSizes } from "../base/theme";

export const FavouriteButtonStyle = css`
    && {
        padding: 0;
        height: 18px;
        width: 20px;
        margin-top: ${gutterSizes.xsmall};
        margin-right: ${gutterSizes.small};

        .favourite-icon {
            font-size: ${fontSizes.pgLarge};
            transition: transform 100ms ease-in;

            &:hover {
                transform: scale(1.2);
            }
        }
    }
`;
